import { render, staticRenderFns } from "./SmsSendLogs.vue?vue&type=template&id=36f73762&scoped=true"
import script from "./SmsSendLogs.vue?vue&type=script&lang=js"
export * from "./SmsSendLogs.vue?vue&type=script&lang=js"
import style0 from "./SmsSendLogs.vue?vue&type=style&index=0&id=36f73762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f73762",
  null
  
)

export default component.exports